import React from 'react';
import PropTypes from 'prop-types';
import { CtaButton } from '../CtaButton';
import { ResponsiveImage } from '../ResponsiveImage';
import {
  StyledSimpleCallout,
  Inner,
  ImageWrapper,
  Content,
  Body,
  ButtonWrapper,
} from './styles.js';

export const SimpleCallout = ({ image, body, link }) => {
  return (
    <StyledSimpleCallout>
      <Inner>
        <ImageWrapper>
          <ResponsiveImage {...image} />
        </ImageWrapper>
        <Content>
          <Body>{body}</Body>
        </Content>
        <ButtonWrapper>
          <CtaButton href={link.target} variant="kale">
            {link.text}
          </CtaButton>
        </ButtonWrapper>
      </Inner>
    </StyledSimpleCallout>
  );
};
SimpleCallout.displayName = 'SimpleCallout';

SimpleCallout.propTypes = {
  image: PropTypes.object.isRequired,
  body: PropTypes.string.isRequired,
  link: PropTypes.shape({
    text: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
  }).isRequired,
};
